import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider } from 'semantic-ui-react';

const textStyle = {
  marginTop: 70,
  fontSize: 18,
};

const buttonStyle = {
  minWidth: 120,
};

const hintStyle = {
  color: 'gray',
  fontSize: 11,
};

const explanationStyle = {
  paddingTop: 25,
};

const doneThatButtonStyle = {
  margin: '0 auto',
  display: 'block',
  ...buttonStyle,
};

const ConfirmationQuestion = ({
  question,
  onPositive,
  onNegative,
  onReset,
  shouldRenderExplanation,
  explanation,
  explanationButtonText,
}) => {
  if (shouldRenderExplanation) {
    return (
      <div style={explanationStyle}>
        {explanation}
        <Divider hidden />
        <Button onClick={onReset} style={doneThatButtonStyle} color="pink">
          {explanationButtonText}
        </Button>
      </div>
    );
  }
  return (
    <div>
      <div style={textStyle}>{question}</div>
      <i style={hintStyle}>click no for further info</i>
      <Divider hidden />
      <Button style={buttonStyle} onClick={onPositive} color="pink">
        Yes
      </Button>
      <Button style={buttonStyle} onClick={onNegative} color="gray">
        No
      </Button>
    </div>
  );
};

ConfirmationQuestion.defaultProps = {
  explanationButtonText: 'Done that!',
};

ConfirmationQuestion.propTypes = {
  question: PropTypes.node.isRequired,
  onPositive: PropTypes.func.isRequired,
  onNegative: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  shouldRenderExplanation: PropTypes.bool.isRequired,
  explanation: PropTypes.node.isRequired,
  explanationButtonText: PropTypes.string,
};

export default ConfirmationQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/confirmation-question/index.js
 **/